module.exports = __webpack_public_path__ + "static/img/watch.8e99838c.png";